import React from 'react';
import { BrainIcon } from 'lucide-react';
export function WhatItIs() {
  return <section id="what-it-is" className="w-full py-20 px-6 md:px-10 lg:px-20 bg-[#111]/80" data-id="element-261">
      <div className="max-w-5xl mx-auto" data-id="element-262">
        <div className="flex items-center mb-6" data-id="element-263">
          <BrainIcon className="w-6 h-6 text-[#00E0FF] mr-3" data-id="element-264" />
          <h2 className="text-lg font-semibold uppercase tracking-wider text-[#00E0FF]" data-id="element-265">
            What It Is
          </h2>
        </div>
        <h3 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-266">
          A full-stack voice-to-voice AI infrastructure, built for businesses
          that want to talk to users in real time — and win.
        </h3>
        <div className="p-8 rounded-xl bg-gradient-to-br from-[#222] to-[#222]/50 border border-gray-800 shadow-lg" data-id="element-267">
          <p className="text-xl leading-relaxed" data-id="element-268">
            Critical Voice is the first AI voice engine that doesn't just
            respond — it understands, adapts, emotes, and persuades. It's
            faster, warmer, more human than anything OpenAI, Google, or Amazon
            has built — because it was engineered not for labs, but for the real
            world.
          </p>
        </div>
      </div>
    </section>;
}